import * as React from 'react';
import styled from 'styled-components';

import { getSemanticAttributes } from '../../internals/semanticProps';
export interface SeparatorProps extends React.HTMLAttributes<HTMLHRElement> {
  orientation?: 'horizontal' | 'vertical';
  decorative?: boolean;
  semanticId?: string;
}

const HorizontalRule = styled.hr`
  box-sizing: border-box;
  width: 100%;
  height: 0;
  margin: 0;
  border: none;
  border-top: 1px solid var(--ui-separator-color, var(--ui-border));
`;

const VerticalRule = styled.div`
  box-sizing: border-box;
  width: 1px;
  min-height: 1em;
  align-self: stretch;
  flex-shrink: 0;
  margin: 0;
  background: var(--ui-separator-color, var(--ui-border));
`;

export const Separator = React.forwardRef<HTMLHRElement | HTMLDivElement, SeparatorProps>(
  function Separator(
    { orientation = 'horizontal', decorative = false, semanticId, ...rest },
    ref,
  ) {
    const semanticProps = getSemanticAttributes(semanticId);
    const role = decorative ? 'none' : 'separator';
    const ariaOrientation = !decorative && orientation === 'vertical' ? 'vertical' : undefined;

    if (orientation === 'vertical') {
      return (
        <VerticalRule
          ref={ref as React.ForwardedRef<HTMLDivElement>}
          role={role}
          aria-orientation={ariaOrientation}
          aria-hidden={decorative ? true : undefined}
          data-orientation={orientation}
          {...semanticProps}
          {...(rest as React.HTMLAttributes<HTMLDivElement>)}
        />
      );
    }

    return (
      <HorizontalRule
        ref={ref as React.ForwardedRef<HTMLHRElement>}
        role={role}
        aria-orientation={ariaOrientation}
        aria-hidden={decorative ? true : undefined}
        data-orientation={orientation}
        {...semanticProps}
        {...rest}
      />
    );
  },
);

Separator.displayName = 'Separator';
